import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "minHeight text" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "answerText" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 1,
    class: "checkBadge"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "answerText" };
const _hoisted_11 = {
    key: 0,
    class: "tick"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
    key: 1,
    class: "amountSliderQuestion"
};
const _hoisted_15 = { class: "center" };
const _hoisted_16 = { class: "amount" };
const _hoisted_17 = {
    key: 0,
    class: "outOf"
};
const _hoisted_18 = { class: "tickLabels" };
const _hoisted_19 = {
    key: 2,
    class: "moneySliderQuestion"
};
const _hoisted_20 = { class: "amount" };
const _hoisted_21 = {
    key: 3,
    class: "textInputQuestion"
};
const _hoisted_22 = {
    key: 4,
    class: "text mt-9 onlyTallScreen"
};
import { ref, computed, watch, onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuestionnaireQuestion',
    props: {
        question: {},
        formatter: {},
        theme: {}
    },
    emits: ["answered"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const selection = ref([]);
        const minAmount = ref(0);
        const maxAmount = ref(10000);
        const stepAmount = ref(100);
        const selectedSliderAmount = ref(0);
        const selectedTextInputAmount = ref(null);
        /* Onboarding theme: single choice = full-width rows, multiple choice = wrapping chips */
        const onboardingLayout = computed(() => {
            if (props.theme !== 'onboarding')
                return null;
            return props.question.multipleChoice ? 'chips' : 'rows';
        });
        /* Icon names come from admin data — a typo or missing asset hides the icon instead of crashing the page */
        function resolveIcon(icon) {
            const name = icon?.trim();
            if (!name)
                return undefined;
            try {
                return require('@/assets/' + name);
            }
            catch {
                console.warn('Questionnaire answer icon not found in src/assets:', name);
                return undefined;
            }
        }
        /* Resolved once at setup, never during render — logging inside render feeds debugLog's reactive list and loops the render */
        const iconSrcs = Object.fromEntries((props.question.possibleAnswers || []).map((a) => [a.answer.id, resolveIcon(a.answer.icon)]));
        const answersHaveIcons = computed(() => {
            if (!props.question || !props.question.possibleAnswers) {
                return false;
            }
            return props.question.possibleAnswers.some((a) => a.answer.icon);
        });
        watch(selectedSliderAmount, () => {
            onSliderAnswerSelected();
        });
        function onLoad() {
            if (props.question.questionType == 1) {
                selectedSliderAmount.value = props.question.defaultAmount;
            }
            if (props.question.selectedAnswer && [1, 2].includes(props.question.questionType)) {
                if (Array.isArray(props.question.selectedAnswer)) {
                    selectedSliderAmount.value = props.question.selectedAnswer[0].amount;
                }
                else {
                    selectedSliderAmount.value = props.question.selectedAnswer;
                }
            }
            if (props.question.questionType == 0) {
                /* Server-restored answers are plain strings; in-session ones are the emitted [{amount}] array */
                const previousAnswer = props.question.selectedAnswer;
                selectedTextInputAmount.value = Array.isArray(previousAnswer) ? previousAnswer[0]?.amount : previousAnswer;
                /* Pre-populated from a previous answer — count it as answered, don't wait for a keystroke */
                if (selectedTextInputAmount.value) {
                    onTextInputAnswerSelected();
                }
            }
            /* Sliders always show a value, so count it as answered straight away — the watch only fires when the value changes, never for an initial 0 */
            if ([1, 2].includes(props.question.questionType)) {
                onSliderAnswerSelected();
            }
            const preselected = props.question.possibleAnswers.filter((a) => a.selected);
            if (preselected.length) {
                selection.value = preselected;
                emit('answered', selection.value);
            }
        }
        function onSliderAnswerSelected() {
            if ([1, 2].includes(props.question.questionType)) {
                selection.value = [{ amount: selectedSliderAmount.value }];
                emit('answered', selection.value);
            }
        }
        function onTextInputAnswerSelected() {
            selection.value = [{ amount: selectedTextInputAmount.value }];
            emit('answered', selection.value);
        }
        function onAnswerSelected(answer) {
            selection.value = [];
            if (!props.question.multipleChoice) {
                props.question.possibleAnswers.forEach((a) => a.selected = false);
            }
            answer.selected = !answer.selected;
            selection.value.push(...props.question.possibleAnswers.filter((a) => a.selected));
            emit('answered', selection.value);
        }
        onMounted(() => { onLoad(); });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_slider = _resolveComponent("v-slider");
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass('question ' + _ctx.theme)
            }, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.question.text), 1),
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.question.subText), 1),
                (_ctx.question.questionType == 4)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["multipleChoiceQuestion", onboardingLayout.value || { hasIcons: answersHaveIcons.value }])
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.possibleAnswers, (a) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: a.id
                            }, [
                                (onboardingLayout.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass('onboardingAnswer ' + (a.selected ? 'selected' : '')),
                                        onClick: ($event) => (onAnswerSelected(a))
                                    }, [
                                        (_unref(iconSrcs)[a.answer.id])
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "avatar",
                                                src: _unref(iconSrcs)[a.answer.id]
                                            }, null, 8, _hoisted_3))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_4, _toDisplayString(a.answer.text), 1),
                                            (a.answer.subText)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(a.answer.subText), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (a.selected)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                                _createVNode(_component_v_icon, {
                                                    size: "12",
                                                    color: "white"
                                                }, {
                                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                        _createTextVNode("mdi-check")
                                                    ])),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 10, _hoisted_2))
                                    : (!answersHaveIcons.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass('multipleChoiceListAnswer ' + (a.selected ? 'selected' : '')),
                                            onClick: ($event) => (onAnswerSelected(a))
                                        }, [
                                            _createVNode(_component_v_row, { class: "answerRow" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                        cols: "1",
                                                        class: "radioCol"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (a.selected)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    class: "radio",
                                                                    src: require('@/assets/filledRadio.png')
                                                                }, null, 8, _hoisted_8))
                                                                : _createCommentVNode("", true),
                                                            (!a.selected)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 1,
                                                                    class: "radio",
                                                                    src: require('@/assets/emptyRadio.png')
                                                                }, null, 8, _hoisted_9))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, { class: "answerTextCol" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("span", _hoisted_10, _toDisplayString(a.answer.text), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, { cols: "1" }, {
                                                        default: _withCtx(() => [
                                                            (a.selected)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                                                    _createVNode(_component_v_icon, { icon: "mdi-check" })
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ], 10, _hoisted_7))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: _normalizeClass('multipleChoiceGridAnswer ' + (a.selected ? 'selected ' : '') + (_ctx.question.possibleAnswers.length > 4 ? 'smallGrid' : 'bigGrid')),
                                            onClick: ($event) => (onAnswerSelected(a))
                                        }, [
                                            _createVNode(_component_v_row, { class: "imgRow" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            (_unref(iconSrcs)[a.answer.id])
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: _unref(iconSrcs)[a.answer.id]
                                                                }, null, 8, _hoisted_13))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1024),
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(a.answer.text), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ], 10, _hoisted_12))
                            ]));
                        }), 128)),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
                    ], 2))
                    : _createCommentVNode("", true),
                (_ctx.question.questionType == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(selectedSliderAmount.value), 1),
                            (_ctx.question.outOf)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "out of " + _toDisplayString(_ctx.question.maxAmount), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_slider, {
                            modelValue: selectedSliderAmount.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedSliderAmount).value = $event)),
                            min: _ctx.question.minAmount,
                            max: _ctx.question.maxAmount,
                            "show-ticks": true,
                            step: 1,
                            "tick-size": 4,
                            "thumb-label": false,
                            class: "slider mt-5"
                        }, null, 8, ["modelValue", "min", "max"]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.question.minLabel), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.question.maxLabel), 1)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.question.questionType == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatter.format(selectedSliderAmount.value)), 1),
                        _createVNode(_component_v_slider, {
                            modelValue: selectedSliderAmount.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedSliderAmount).value = $event)),
                            min: minAmount.value,
                            max: maxAmount.value,
                            step: stepAmount.value,
                            "tick-size": "4",
                            "thumb-label": false,
                            class: "slider mt-5"
                        }, null, 8, ["modelValue", "min", "max", "step"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.question.questionType == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_v_text_field, {
                            modelValue: selectedTextInputAmount.value,
                            "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event) => ((selectedTextInputAmount).value = $event)),
                                onTextInputAnswerSelected
                            ]
                        }, null, 8, ["modelValue"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.question.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.question.description), 1))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
